import type React from 'react';

type ComposeProps = {
  components: [component: React.FC<{ children: React.ReactNode }>, props?: any][];
  children: React.ReactNode;
};

/**
 * Returns the provided components (instantitated with any provided props)
 * wrapped around the provided children.
 */
export const Compose = ({ components: providers, children }: ComposeProps) => (
  <>
    {providers.reduceRight(
      (children: React.ReactNode, [Component, props]) => (
        <Component {...props}>{children}</Component>
      ),
      children
    )}
  </>
);
